/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unused-vars */
export const onSuccess = (key, willSave = true) => (state, { payload }) => {
  if (payload && willSave) {
    state[key] = payload;
  }
  state.errors[key] = null;
};

export const onFailure = (key) => (state, { payload: { response = {} } }) => {
  if (key) {
    state.errors[key] = response;
  } else {
    state.errors = response;
  }
};

export const onSuccessDetail = (key, field = 'slug') => (
  state,
  { payload },
) => {
  const detailContainer = state[key];
  if (payload) {
    const containerId = payload[field];
    detailContainer[containerId] = payload;
  }
  state.errors[key] = null;
};

export const onSuccessList = (key) => (
  state,
  { payload: { results, next, count } },
) => {
  state[key] = results;
  state.next[key] = next;
  state.count[key] = count;
  state.errors[key] = null;
};

export const onSuccessConcatList = (key) => (
  state,
  { payload: { results, next, count } },
) => {
  const list = state[key] || [];
  state[key] = list.concat(results);
  state.next[key] = next;
  state.count[key] = count;
  state.errors[key] = null;
};

export const handleResetList = (state, { payload: key }) => {
  state[key] = null;
  state.next[key] = null;
  state.count[key] = null;
};

export const handleClearErrors = (state) => {
  state.errors = {};
};

export const handleUpdateField = (state, { payload: { key, value } }) => {
  state[key] = value;
};
